module.exports = __webpack_public_path__ + "static/5-b5706cfa506ab0a8ddb6840e21644e78.png";